var React = require('react');

function IconmonstrFile24 (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M11.362 2c4.156 0 2.638 6 2.638 6s6-1.65 6 2.457v11.543h-16v-20h7.362zm.827-2h-10.189v24h20v-14.386c0-2.391-6.648-9.614-9.811-9.614zm4.811 13h-3v-1h3v1zm0 2h-3v1h3v-1zm0 3h-10v1h10v-1zm-5-6h-5v4h5v-4z"}));
}

IconmonstrFile24.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = IconmonstrFile24;

IconmonstrFile24.default = IconmonstrFile24;
